import {GoogleOAuthProvider, useGoogleLogin} from '@react-oauth/google';
import associateServices from "../../../services";
import SESSION_HELPER from "../../../helpers/session-helper";
import {toast} from "react-toastify";
import store from "../../../reducers/createReducers";
import AUTHENTICATION_ACTIONS from "../../../actions/authentication-actions";
import {useTranslation} from "react-i18next";
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import {useEffect, useRef} from "react";
import {Helmet} from "react-helmet-async";
import SvgIcon from "../../../components/svg-icon";
import SocialAuthsGoogle from "./social-auths-google";

const RegisterSocialAuth = props => {

    const {t} = useTranslation()
    const {setLoading, handleClose, settings} = props

    const responseFacebook = (response) => {
        console.log(response);
        // Handle the response (successful login, errors, etc.)
        if (response.status === 'unknown') {
            console.error('Login failed');
        } else {
            // You can send the response data to your backend or use it as needed
            console.log('User data:', response);
        }
    };

    const handleTelegramLogin = () => {
        const payload = {
            a: "r",
            d: window.location.origin,
        };

        // Convert JSON to string
        const jsonString = JSON.stringify(payload);

        // Base64 encode the string
        const encodedPayload = btoa(jsonString);

        const urlSafePayload = encodedPayload.replace(/=+$/, ""); // Outputs: "eyJhIjoiciIsImQiOiJodHRwOi8vbG9jYWxob3N0OjMwMDAifQ"
        // MrGambRegisterBot
        window.open(`https://t.me/${settings?.telegram_bot_id}?start=${urlSafePayload}`, "_blank");

    };

    return (
        <div className="form__social">

            {
                settings?.facebook_able &&
                <FacebookLogin
                    appId={settings?.facebook_app_id} // Replace with your App ID
                    fields="name,email,picture"
                    callback={responseFacebook}
                    render={renderProps => (
                        <a onClick={renderProps.onClick}>
                            <SvgIcon id={'facebook'}/>
                        </a>
                    )}
                />
            }

            {
                settings?.google_client_id &&
                <GoogleOAuthProvider
                    clientId={settings?.google_client_id}>
                    <SocialAuthsGoogle settings={settings}
                                       handleClose={handleClose}
                                       setLoading={setLoading}
                    />
                </GoogleOAuthProvider>
            }


            {
                settings?.telegram_able && settings?.telegram_bot_id &&
                <a onClick={handleTelegramLogin} id="telegram-button">
                    <SvgIcon id={'telegram'}/>
                </a>
            }


        </div>
    )

}

export default RegisterSocialAuth;

